import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useCampaignsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'campaigns', api: api.campaigns }, queryVariables, queryConfig);

  return {
    campaigns: queryResult.resolvedData,
    latestCampaigns: queryResult.latestData,
    ...queryResult,
  };
};

export const useCampaign = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['campaign', { id }], api.campaigns.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    campaign: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'campaigns' });

export const useDeleteCampaign = createMutation(api.campaigns.remove);

export const useCreateCampaign = createMutation(api.campaigns.create);

export const useSaveCampaign = createMutation(api.campaigns.save);

export const useUpdateCampaign = createMutation(api.campaigns.update);
